import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { handleLaunchAuth, setAuthPersisted, clearAuthPersisted } from '../services/pinUtils';

export const SESSION_KEY = 'pin_session_authenticated';

interface AuthContextType {
  isAuthenticated: boolean;
  login: () => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  login: () => {},
  logout: () => {},
});

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Always start unauthenticated on fresh launch — sessionStorage clears on tab/PWA close
  //const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    return handleLaunchAuth();   // ← replaces the old sessionStorage check
  });

  useEffect(() => {
    // On mount, check if already authenticated in this session
    const sessionAuth = sessionStorage.getItem(SESSION_KEY);
    if (sessionAuth === 'true') {
      //console.log("AuthContext setIsAuthenticated(true)");
      setIsAuthenticated(true);
    }    
  }, []);
/*
  const login = () => {
    sessionStorage.setItem(SESSION_KEY, 'true');
    setIsAuthenticated(true);
  };

  const logout = () => {
    sessionStorage.removeItem(SESSION_KEY);
    setIsAuthenticated(false);
  };
*/
  const login = () => {
    localStorage.setItem('app_authenticated', 'true');
    sessionStorage.setItem(SESSION_KEY, "true");
    setIsAuthenticated(true);
  };

  const logout = () => {
    clearAuthPersisted();
    sessionStorage.setItem(SESSION_KEY,"false");
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
